<template>
    <one-column-layout title="Experiences">
        <template v-slot:header>
            <Header/>
        </template>
        <template>
            <div>
                <div class="row no-gutters mb-3" :style="isMobile? 'margin-top: 150px' : ''">
                    <div class="col-7 col-md-9 filter-panel">
                        <div class="filter-control">
                            <div class="d-flex justify-content-between"  @click="onOpenCloseFilter">
                                <div>
                                    <a href="javascript:void(0)" class="text-secondary"><b>{{isMobile? 'Filtra' : 'Filtra risultati'}}</b><span> | {{counter}}</span></a>
                                </div>
                                <div>
                                    <button class="btn btn-sm btn-secondary mr-2" @click="onResetFilter">reset</button>
                                </div>
                            </div>
                            <div @mouseleave="openFilter = false">
                                <DropdownFilterExperience v-show="openFilter" :list="list" :value="filter" @change="onChangeFilter"/>
                            </div>
                        </div>
                    </div>
                    <div class="pl-3 col-5 col-md-3">
                        <CustomOrderSelect class="lg gray" :list="orders" :value="order" @change="onChangeOrder" />
                    </div>
                </div>
                <div>
                    <div v-for="(item, index) in listFiltered" :key="index" class="mb-3" ref="listRef">
                        <HorizontalItemExperience :value="item" :search="search" @select="onSelect"/>
                    </div>
                </div>
            </div>
        </template>
    </one-column-layout>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import OneColumnLayout from './layout/OneColumLayout'
import DropdownFilterExperience from '../widgets/pages/experience/dropdown/DropdownFilterExperience'
import Header from '../widgets/pages/experience/layout/Header'
import HorizontalItemExperience from '../widgets/pages/experience/HorizontalItemExperience'
import CustomOrderSelect from '../widgets/common/CustomOrderSelect'
import {defaultFiltererExperience, defaultSorterExperience} from '../../utils/experienceUtils'
import ExperienceSearcher from '../searcher/ExperienceSearcher'
import MobileDetector from '../common/MobileDetector'
import {isDateInPeriod} from '../../utils/helper'
import {CONFIG_DATE_FORMAT_2} from '../../utils/formatter'

export default {
  name: 'ExperienceSelection',
  mixins: [ExperienceSearcher, MobileDetector],
  components: {CustomOrderSelect, HorizontalItemExperience, Header, DropdownFilterExperience, OneColumnLayout},
  data: function () {
    return {
      openFilter: false,
      tourSelected: null,
      camere: [{adults: 2, childs: []}],
      sort: null,
      orders: [
        {name: 'categoria', dir: 'up'},
        {name: 'categoria', dir: 'down'},
        {name: 'durata', dir: 'up'},
        {name: 'durata', dir: 'down'}
      ]
    }
  },

  computed: {
    filter () {
      return this.getExperienceFilter()
    },
    order () {
      return {name: 'categoria', dir: this.getOrder()['categoria']}
    },
    search () {
      return this.getSearch()
    },
    list () {
      return this.getListExperience()
    },
    aereoporti () {
      return this.getTypesAereoporti().map(function (item) {
        return {label: item.name, value: item.id}
      })
    },
    listFiltered () {
      return this.list.filter(item => {
        if (item.datesRangeStagionalita.length === 0) return true
        const now = this.search.partenza
        const start = this.$moment(item.datesRangeStagionalita[0], CONFIG_DATE_FORMAT_2).toDate()
        const end = this.$moment(item.datesRangeStagionalita[1], CONFIG_DATE_FORMAT_2).toDate()
        const result = isDateInPeriod(now, {start, end})
        return result
      }).filter(this.filterer).sort(this.sorterer)
    },
    counter () {
      return this.list.length
    },
    prices () {
      return this.list.map(item => {
        return this.getItemMinPrice(item)
      })
    }
  },
  methods: {
    ...mapGetters(['getSearch', 'getExperiences', 'getListExperience', 'getExperienceOrder', 'getExperienceFilter', 'getItinerario']),
    ...mapActions(['loadExperiences', 'modifyExperience', 'modifyExperienceOrder', 'resetExperienceFilter', 'loadingStart', 'loadingEnd']),
    getItemMinPrice (item) {
      return item.element.departuresDatePrice.map(item => item.price.importo).reduce((totale, current) => {
        return Math.min(totale, current)
      })
    },
    getOrder () {
      return this.getExperienceOrder()
    },
    resetFilter () {
      this.resetExperienceFilter()
    },
    filterer (item) {
      return defaultFiltererExperience(item, this.filter)
    },
    sorterer (a, b) {
      const order = this.getOrder()
      return defaultSorterExperience(a, b, order)
    },
    onSelect (data) {
      this.searchExperienceDetail(data)
    },
    onOpenCloseFilter () {
      this.openFilter = !this.openFilter
    },
    onChangeOrder (order) {
      this.modifyExperienceOrder({[order.name]: order.dir})
    },
    onChangeFilter (filter) {
      this.modifyTourFilter(filter)
    },
    onResetFilter (event) {
      event.stopPropagation()
      this.resetFilter()
      this.openFilter = false
    }
  },
  created () {
    const list = this.getExperiences()
    this.loadExperiences(list)
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/ExperienceSelection.vue